(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  var $slider = $('.js_section_product');

  if ($slider.hasClass('slick-initialized')) {

    $slider.slick('slickSetOption', {
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false
    }, true);

    $slider.slick('slickPlay');
  }

});

  } catch(e) { console.error(e); }
})();
})();
